module.exports = __webpack_public_path__ + "static/media/1902_Emilia_con_Anna.d13c1ace.jpg";